export enum ErrorPageType {
    UNSUPPORTED_BROWSER = 'unsupported-browser',
    UNSUPPORTED_TOUCH = 'unsupported-touch',
    UNSUPPORTED_ELECTRON = 'unsupported-electron',
    UNSUPPORTED_MESSENGER = 'unsupported-messenger',
    GONE = 'gone',
    FORBIDDEN = 'forbidden',
    OVERLOADED = 'overloaded',
    DEFAULT = 'default',
    LIMIT_USERS_COUNT = 'limit-users-count',
    NOT_IN_EXPERIMENT = 'not-in-experiment',
    UNAUTHORIZED = 'unauthorized',
    NOT_FOUND = 'not-found',
    NOT_STARTED = 'not-started',
    BROADCAST_GONE = 'broadcast-gone',
    BROADCAST_NOT_FOUND = 'broadcast-not-found',
    ORGANIZATION_MISMATCHES = 'organization-mismatches',
    BROADCAST_ORGANIZATION_MISMATCHES = 'broadcast-organization-mismatches',
    USER_KECKED = 'user-kicked',
    USER_KICKED_WITH_BAN = 'user-kicked-with-ban',
}
